export default __webpack_public_path__ + "static/media/Fondo-Login.729e0956.jpg";